module.exports = __webpack_public_path__ + "img/section4Logo4.62e1aa6f.webp";